export const AUTH_REF_TYPES = {
  AUTHORIZED: 'Authorized',
  REFERENCE: 'Reference',
  AUTH_REF: 'Auth/Ref',
};
